export const EVENT_TYPES = [
  {
    id: 'ATTENDANCE',
    label: 'Invitation',
    icon: '🎉',
    description: 'Send invitations and collect RSVPs.',
    color: 'emerald',
  },
  {
    id: 'SPLITWISE',
    label: 'Expense Sharing',
    icon: '💸',
    description: 'Track expenses and calculate who owes whom.',
    color: 'amber',
  },
  {
    id: 'EXPENSE_TRACKING',
    label: 'Expense tracking',
    icon: '🧾',
    description: 'Log items, amounts, place, paid/udhaar, and receipts in the channel.',
    color: 'orange',
  },
  {
    id: 'CALCULATION',
    label: 'Calculation',
    icon: '🧮',
    description: 'Perform calculations based on participant inputs.',
    color: 'violet',
  },
  {
    id: 'POLL',
    label: 'Poll',
    icon: '📊',
    description: 'Collect responses and determine the result.',
    color: 'blue',
  },
  {
    id: 'TASK',
    label: 'Task',
    icon: '✓',
    description: 'Assign and track tasks for participants.',
    color: 'indigo',
  },
  {
    id: 'MEETING',
    label: 'Meeting',
    icon: '📅',
    description: 'Schedule a meeting with RSVPs and reminders.',
    color: 'sky',
  },
  {
    id: 'CUSTOM',
    label: 'Custom',
    icon: '⚙️',
    description: 'Build a custom event with flexible rules.',
    color: 'slate',
  },
];

export const EVENT_CATEGORIES = [
  { id: 'PERSONAL', label: 'Personal' },
  { id: 'WORK', label: 'Work' },
  { id: 'FINANCE', label: 'Finance' },
  { id: 'SOCIAL', label: 'Social' },
  { id: 'EDUCATION', label: 'Education' },
  { id: 'OTHER', label: 'Other' },
];

export const RESPONSE_TYPES = [
  { id: 'NONE', label: 'No response required' },
  { id: 'RSVP', label: 'RSVP' },
  { id: 'ACCEPT_REJECT', label: 'Accept / Reject' },
  { id: 'YES_NO_MAYBE', label: 'Yes / No / Maybe' },
  { id: 'POLL', label: 'Poll' },
  { id: 'MULTIPLE_CHOICE', label: 'Multiple Choice' },
];

export const RECURRENCE_OPTIONS = [
  { id: 'NONE', label: 'Does not repeat' },
  { id: 'DAILY', label: 'Daily' },
  { id: 'WEEKLY', label: 'Weekly' },
  { id: 'MONTHLY', label: 'Monthly' },
  { id: 'CUSTOM', label: 'Custom' },
];

export const VISIBILITY_OPTIONS = [
  { id: 'PARTICIPANTS_ONLY', label: 'Participants only' },
  { id: 'GROUP_MEMBERS', label: 'Group members' },
  { id: 'EVERYONE', label: 'Everyone' },
  { id: 'PRIVATE', label: 'Private' },
];

export const COMPLETION_ACTION_TYPES = [
  { id: 'SEND_MESSAGE', label: 'Send message to everyone' },
  { id: 'SEND_CONGRATULATIONS', label: 'Send congratulations message' },
  { id: 'TRIGGER_EVENT', label: 'Trigger another event' },
  { id: 'CREATE_TASK', label: 'Create follow-up task' },
  { id: 'SETTLEMENT', label: 'Start payment settlement' },
  { id: 'GENERATE_REPORT', label: 'Generate report' },
  { id: 'UPDATE_ATTENDANCE', label: 'Update attendance' },
  { id: 'CALCULATE_RESULT', label: 'Calculate result' },
  { id: 'SEND_NOTIFICATION', label: 'Send notification' },
  { id: 'ARCHIVE', label: 'Archive event' },
];

export const NOTIFICATION_CHANNELS = [
  { id: 'IN_APP', label: 'In-app', enabled: true },
  { id: 'PUSH', label: 'Push', enabled: true },
  { id: 'EMAIL', label: 'Email', enabled: false },
  { id: 'SMS', label: 'SMS', enabled: false },
  { id: 'WHATSAPP', label: 'WhatsApp', enabled: false },
  { id: 'SLACK', label: 'Slack / Teams', enabled: false },
];

export const EVENT_STATUS_LABELS = {
  DRAFT: 'Draft',
  CREATED: 'Created',
  INVITATION_SENT: 'Invitation sent',
  WAITING_FOR_RESPONSE: 'Waiting for response',
  CONFIRMED: 'Confirmed',
  IN_PROGRESS: 'In progress',
  COMPLETED: 'Completed',
  POST_COMPLETION: 'Post-completion',
  CLOSED: 'Closed',
  CANCELLED: 'Cancelled',
  DELETED: 'Deleted',
  EXPIRED: 'Expired',
};

export const getEventType = (id) => EVENT_TYPES.find((t) => t.id === id);
